<script>
  import { Section, Rectangle, Label } from '@snlab/florence'
  import { scaleLinear } from 'd3-scale'

  export let height
  export let width
  export let active
  export let top3
</script>

<Section
  x1={0}
  x2={width / 3}
  y1={height - height / 3}
  y2={height}
  flipY
  scaleX={scaleLinear().domain([0, 100])}
  scaleY={scaleLinear().domain([0, 300])}>
  <Label x={0} y={300} anchorPoint="lt" text="Infobox" fontWeight="600" />
  {#if active}
    <Label
      x={0}
      y={250}
      anchorPoint="lt"
      fontSize="12"
      text={'There are ~' + Math.ceil(active / 25) * 25}
      fontWeight="200" />
    <Label
      x={0}
      y={225}
      anchorPoint="lt"
      fontSize="12"
      text={'fashion tweets here.'}
      fontWeight="200" />
    <Label
      x={0}
      y={175}
      anchorPoint="lt"
      fontSize="12"
      text={'Top 3 categories'}
      fontWeight="400" />
    {#each top3 as item, index}
      <Label
        x={0}
        y={140 - index * 30}
        anchorPoint="lt"
        fontSize="12"
        text={index + 1 + '. ' + item}
        fontWeight="200" />
    {/each}
  {:else}
    <Label
      x={0}
      y={250}
      anchorPoint="lt"
      fontSize="12"
      text="Hover over a location"
      fontWeight="200" />
    <Label
      x={0}
      y={225}
      anchorPoint="lt"
      fontSize="12"
      text="to find out more!"
      fontWeight="200" />
  {/if}
</Section>
